<template>
	<svg viewBox="0 0 100 100" class="stroke-current">
		<circle cx="50" cy="50" fill="none" stroke-width="5" r="45" stroke-dasharray="212.05750411731105 72.68583470577035">
			<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
		</circle>
	</svg>
</template>
